












import { Component, Vue } from "vue-property-decorator";
import companyManagerWrapper from "@/components/knockoutWrappers/CompanyManagerWrapper.vue";
import events from "App/events";
import { SnackbarConfig } from "@/types/snackbarConfig";
import htmlEncoder from "Utilities/htmlencode-helper";

@Component({
  components: {
    companyManagerWrapper,
  },
})
export default class CompanyManager extends Vue {
  companyOnCreatedBinding: any = null;
  companyOnUpdatedBinding: any = null;
  companyOnRemovedBinding: any = null;

  message(action: string, companyName: string): Partial<SnackbarConfig> {
    let text = `Company '${htmlEncoder.htmlEncode(companyName)}' has been `;
    switch (action) {
      case "companyOnCreated":
        text += "<b>created</b>";
        break;

      case "companyOnUpdated":
        text += "<b>updated</b>";
        break;

      case "companyOnRemoved":
        text += "<b>removed</b>";
        break;
    }

    return {
      text: text,
      color: "success",
    };
  }

  mounted(): void {
    this.companyOnCreatedBinding = events.companyOnCreated.add((company: any) => {
      this.$store.dispatch("Snackbar/showSnackbar", this.message("companyOnCreated", company.name));
    });

    this.companyOnUpdatedBinding = events.companyOnUpdated.add((company: any) => {
      this.$store.dispatch("Snackbar/showSnackbar", this.message("companyOnUpdated", company.name));
    });

    this.companyOnRemovedBinding = events.companyOnRemoved.add((company: any) => {
      this.$store.dispatch("Snackbar/showSnackbar", this.message("companyOnRemoved", company.name));
    });
  }

  beforeDestroy(): void {
    this.companyOnCreatedBinding.detach();
    this.companyOnUpdatedBinding.detach();
    this.companyOnRemovedBinding.detach();
  }
}
